import type { CSSProperties, ReactNode } from 'react'

import { useOptionalConditionalFormat } from './ConditionalFormatContext'

export function FormattedTableCell({
  columnKey,
  value,
  className = '',
  children,
}: {
  columnKey: string
  value: unknown
  className?: string
  children?: ReactNode
}) {
  const ctx = useOptionalConditionalFormat()
  const style: CSSProperties | undefined = ctx?.cellStyle(columnKey, value)

  return (
    <td className={className} style={style} data-heatmap={style ? '' : undefined}>
      {children ?? (value == null || value === '' ? '—' : String(value))}
    </td>
  )
}
